import 'isomorphic-fetch';
import { getConfigurationByEnv } from '../config/myvw-configs';

export async function fetchGoogleMaps(
  locale: string,
  baseUrl?: string,
): Promise<string> {
  const configJson = getConfigurationByEnv(baseUrl);
  const response = await fetch(`${configJson.url}/googleMaps`, {
    headers: { locale: locale },
  });
  if (!response.ok) {
    throw new Error('Failed to fetch Google Maps API key');
  }

  const data = await response.json();
  const decodedString = atob(data.base64Encoded);
  const apiKey = JSON.parse(decodedString);

  return `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places`;
}
